// The SSO user profile travels between the ACT consoles as base64: in the
// ?info= query param from the Auth Portal, and in localStorage (user_info).
// It used to be written with btoa(JSON.stringify(...)), which only handles
// Latin-1 and throws for names such as "Łukasz" or "O’Brien" (SID-2225).
//
// encodeUserInfo writes UTF-8. decodeUserInfo reads UTF-8 and falls back to
// Latin-1, so profiles written the old way (e.g. "José") still decode, and
// ASCII-only profiles encode exactly as before.

const CHUNK = 0x8000;

const bytesToBase64 = (bytes) => {
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
};

const base64ToText = (base64) => {
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    // Not valid UTF-8: written by btoa as Latin-1 before SID-2225.
    return binary;
  }
};

// Returns the base64 string for a profile object.
export const encodeUserInfo = (value) =>
  bytesToBase64(new TextEncoder().encode(JSON.stringify(value)));

// Returns the parsed profile, or null if it's missing or can't be read. Also
// accepts the double-encoded form (a JSON string holding the JSON) that some
// portal links produce.
export const decodeUserInfo = (base64) => {
  if (!base64) return null;
  try {
    let value = JSON.parse(base64ToText(base64));
    if (typeof value === "string") value = JSON.parse(value);
    return value && typeof value === "object" ? value : null;
  } catch {
    return null;
  }
};
